<template>
  <div class="p-4">
    <div class="list-group border-bottom mb-4" v-if="order.documents.length > 0">
      <a v-for="doc in order.documents" target="_blank" :key="doc.id"
        class="list-group-item"
        :href="`${baseUrl}/special-orders/${order.id}/docs/${doc.file_hash}/${doc.filename}`"
      >{{ doc.filename }}</a>
    </div>
    <div v-else class="text-center">
      No documents
    </div>
    <div>
      <input type="file" id="file" ref="file" @change="handleFileUpload" style="display: none;" />
      <button class="btn btn-sm btn-outline-dark" @click="handleClick">
        <i v-if="uploading" class="fa fa-spinner fa-spin"></i>
        Add Document
      </button>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import auth from '@/libs/auth'

export default {
  name: 'docs-tab',
  props: {
    order: Object,
  },

  data() {
    return {
      uploading: false,
      baseUrl: api.baseUrl,
      file: ''
    }
  },

  components: {
  },

  computed: {
    url() {
      return `/special-orders/${this.order.id}/docs`
    },
  },

  methods: {
    handleClick() {
      this.file = this.$refs.file.click()
    },

    submitFile(){
      this.uploading = true
      let formData = new FormData()
      formData.append('file', this.file)

      api.post(this.url, formData, {
        headers: { Authorization: auth.getToken() }
      }).then(res => {
        this.order.documents = res.data.order.documents
        this.uploading = false
      })
      .catch(function(err){
        alert('FAILURE!!' + err)
      })
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.submitFile()
    }
  }
}
</script>
